import { signal } from '@angular/core';

import { injectLoadTranslations, TranslateParams } from './load-translations';

export const injectCreateErrorTips = (errorKeys: TranslateParams) => {
  const loadTranslations = injectLoadTranslations();
  const errorTips = signal<Record<string, Record<string, string>>>({});

  loadTranslations(errorKeys).subscribe((translations) => {
    errorTips.set({
      default: translations,
    });
  });
  return errorTips;
};
